import {
  Box,
  Button,
  Container,
  Heading,
  HStack,
  Stack,
  Text,
  useToast,
} from "@chakra-ui/react"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import AddProduct from "../../../../components/WMS/Products/AddProduct"

export const Route = createFileRoute("/_layout/WMS/products/create")({
  component: CreateProductPage,
})

function CreateProductPage() {
  const navigate = useNavigate()
  const toast = useToast()

  return (
    <Container maxW="10xl" py={6}>
      <Stack spacing={6}>
        <HStack justify="space-between" align="start" wrap="wrap" spacing={4}>
          <Box>
            <Heading size="lg">Dodaj produkt</Heading>
            <Text color="gray.500" mt={2}>
              Formularz tworzenia produktu został przeniesiony na osobną stronę,
              żeby wygodniej pracować z większą liczbą pól i plikami.
            </Text>
          </Box>
          <HStack wrap="wrap">
            <Button
              onClick={() =>
                navigate({
                  to: "/WMS/products/products-list",
                  search: {
                    q: "",
                    page: 1,
                    page_size: 50,
                  },
                })
              }
            >
              Wróć
            </Button>
          </HStack>
        </HStack>

        <Box borderWidth="1px" borderRadius="xl" p={{ base: 4, md: 6 }}>
          <AddProduct
            onSuccess={(created) => {
              toast({
                title: "Produkt został pomyślnie utworzony",
                status: "success",
              })
              navigate({
                to: "/WMS/products/$product",
                params: { product: created.id },
              })
            }}
            onCancel={() =>
              navigate({
                to: "/WMS/products/products-list",
                search: {
                  q: "",
                  page: 1,
                  page_size: 50,
                },
              })
            }
          />
        </Box>
      </Stack>
    </Container>
  )
}
